import { createRoot } from "react-dom/client";
import sbjs from "sourcebuster";

import { App } from "./App";

declare global {
	interface Window {
		global: unknown;
	}
}

if (typeof window !== "undefined") {
	window.global = window;
}

/**
 * Default config from:
 * /plugins/woocommerce/src/Internal/Orders/OrderAttributionController.php
 */
sbjs.init({
	lifetime: Number(0.00001),
	session_length: Number(30),
	timezone_offset: 0, // utc
});

const rootElement = document.getElementById(`root`);

if (rootElement) {
	createRoot(rootElement).render(<App />);
}

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
